<template>
  <svg :class="className">
    <use :xlink:href="link" />
  </svg>
</template>

<script>
  export default {
    name: 'icon',
    props: ['className', 'link'],
  };
</script>

<style scoped>
  .icon {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom-icons/Icon.vue